import { render, staticRenderFns } from "./ProfissionaisPorFuncaoComponent.vue?vue&type=template&id=3efe4d06"
import script from "./ProfissionaisPorFuncaoComponent.vue?vue&type=script&lang=js"
export * from "./ProfissionaisPorFuncaoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports